export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import {bind, AnchorLinkProps} from 'kpc';

interface Props {
    activeAnchor?: string
    logs: string[]
}

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {
            activeAnchor: 'section_one',
            logs: [],
        }
    }

    @bind
    handleAnchorClick(e: MouseEvent, link: AnchorLinkProps) {
        const logs = this.get('logs') || [];
        this.set('logs', [...logs, `点击了锚点: title: ${link.title} href: ${link.href}`]);
    }

    @bind
    handleAnchorChange(href: string) {
        const logs = this.get('logs') || [];
        this.set('logs', [...logs, `锚点改变为: ${href}`])
    }
}